import { APP_STORE_APP_LINK, PLAY_MARKET_APP_LINK } from '../constants/env';

import { isValidUrlByRegex } from './isValidUrlByRegex';

const checkIsAppStoreLinksAvailability = () => {
  const showPlayMarketLink = isValidUrlByRegex(PLAY_MARKET_APP_LINK);

  const showAppStoreLink = isValidUrlByRegex(APP_STORE_APP_LINK);

  const hasAtLeastOneStoreLink = showPlayMarketLink || showAppStoreLink;

  return { hasAtLeastOneStoreLink, showAppStoreLink, showPlayMarketLink };
};

export default checkIsAppStoreLinksAvailability;



// WEBPACK FOOTER //
// ./src/utils/checkIsAppStoreLinksAvailability.js